import _ from 'lodash';
import { cornerSolutions } from './generators/shapes';

export function calculateFrontEdgeLength(shape) {
  const shapeId = shape.getIn(['value', 'id']);
  const m = shape.get('measurements');
  switch (shapeId) {
    case 'rectangular': return m.get('a');
    case 'l-shape': return (m.get('a') - m.get('d')) + (m.get('b') - m.get('c'));
    case 'u-shape': return (m.get('a') - m.get('e') - m.get('f')) + (m.get('b') - m.get('d')) + (m.get('c') - m.get('d'));
    case 'ii-shape': return m.get('a') + m.get('c');
    case 'irregular': return m.get('a');
    case 'v-shape': return (m.get('a') - cornerSolutions.deepCornerVshape) + (m.get('b') - cornerSolutions.deepCornerVshape) + cornerSolutions.frontEdge;
    case 'c-shape': return (m.get('a') - cornerSolutions.deepCornerCshape) + (m.get('b') - cornerSolutions.deepCornerCshape) + cornerSolutions.frontEdge;
    case 'g-shape': return (m.get('a') - m.get('f') - m.get('h')) + (m.get('b') - m.get('e') - m.get('g')) + (m.get('c') - m.get('e')) + (m.get('d') - m.get('f'));
    default: throw new Error('Unsupported shapeId');
  }
}

export function calculateArcOverhangFrontEdgeLengthToRemove(plannedShape, walls, overhangSideDimensions) {
  const frontEdge = overhangSideDimensions.reduce((total, dimension) => {
    if (!walls.includes(dimension.get(length))) {
      return total + (plannedShape.getIn(['measurements', dimension.get('depth')]) / 2);
    } else {
      return total;
    }
  }, 0);
  return Math.floor(frontEdge);
}

export function calculateVisibleEdgeLength(shape, walls) {
  const shapeId = shape.getIn(['value', 'id']);
  const m = shape.get('measurements');
  const edgeLength = createEdgeCalculator(m, walls);

  switch (shapeId) {
    case 'rectangular': return edgeLength('a') + edgeLength('b', 2);
    case 'kitchen-island': return edgeLength('a') + edgeLength('b', 2);
    case 'l-shape': return edgeLength('a') + edgeLength('b') + edgeLength('c') + edgeLength('d');
    case 'u-shape': return edgeLength('a') + edgeLength('b') + edgeLength('c') + edgeLength('e') + edgeLength('f');
    case 'ii-shape': return edgeLength('a') + edgeLength('b', 2) + edgeLength('c') + edgeLength('d', 2);
    case 'irregular': return edgeLength('d') + edgeLength('b') + edgeLength('c');
    case 'v-shape': return edgeLength('a') + edgeLength('b') + edgeLength('c') + edgeLength('d');
    case 'c-shape': return edgeLength('a') + edgeLength('b') + edgeLength('c') + edgeLength('d') + edgeLength('f');
    case 'g-shape': return edgeLength('a') + edgeLength('b') + edgeLength('c') + edgeLength('d') + edgeLength('g') + edgeLength('h');
    default: throw new Error('Unsupported shapeId');
  }
}

export function calculateWaterfallEdgeLength(waterfallHeight, walls, overhangSideDimensions) {
  return overhangSideDimensions.reduce((total, dimension) => {
    if (!walls.includes(dimension.get('length'))) {
      return total + waterfallHeight;
    } else {
      return total;
    }
  }, 0);
}

export function calculateArcOverhangLength(plannedShape, walls, overhangSideDimensions) {
  const visibleEdge = overhangSideDimensions.reduce((total, dimension) => {
    if (!walls.includes(dimension.get(length))) {
      return total + (plannedShape.getIn(['measurements', dimension.get('depth')]) * ((Math.PI / 2) - (3 / 2)));
    } else {
      return total;
    }
  }, 0);
  return Math.floor(visibleEdge);
}

export function calculateKitchenIslandVisibleEdgeLength(measurements) {
  return measurements.get('a') + (measurements.get('b') * 2);
}

function createEdgeCalculator(m, walls) {
  const wallCounts = _.countBy(walls, (value) => value);

  return (dimension, count = 1) => {
    const wallCount = wallCounts[dimension] || 0;
    const diff = count - wallCount;

    return diff * m.get(dimension);
  };
}
